import { NgModule, Pipe, PipeTransform } from '@angular/core';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';

@Pipe({
  name: 'relativeTime',
})
export class RelativeTimePipe implements PipeTransform {
  transform(date: string, localeString: string = 'en'): string {
    const today = new Date();
    const specifiedDate = new Date(date);
    const locale = localeString === 'en' ? en : es;

    const dayDifference = (first, second) =>
      first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      Math.abs(first.getDate() - second.getDate());

    const isToday = dayDifference(today, specifiedDate) === 0;
    if (isToday) {
      const offsetDate = new Date(date + 'Z');
      return formatDistanceToNow(offsetDate, { locale, addSuffix: true });
    }

    const isYesterday = dayDifference(today, specifiedDate) === 1;
    if (isYesterday) {
      return localeString === 'en' ? 'yesterday' : 'ayer';
    }

    return specifiedDate.toLocaleDateString(localeString, {
      year: 'numeric', month: 'short', day: 'numeric',
    });
  }
}

@NgModule({
  declarations: [RelativeTimePipe],
  exports: [RelativeTimePipe]
})
export class RelativeTimePipeModule {}
